import type {
	BusinessObjectIdType,
	ModuleIdType,
	TsCodeType,
	VariableNameType,
	HtmlType,
} from '../../types.js'
import { Block } from '../block.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
	jsonMapProperty,
} from '@sumbricht/json-class-serializer'
import { ScreenEditorInput } from '../decorators/screen-editor-input.js'

@jsonClass('RawHtmlBlock')
export class RawHtmlBlock extends Block {
	@jsonProperty(String)
	@ScreenEditorInput({
		inputType: 'code',
		order: 1,
		label: 'HTML',
		tooltip: () => ({
			text: 'To insert the content of a Content Area named "content", use the following in your HTML: <code>{{CONTENT:content}}</code>',
			acceptHtml: true,
		}),
		codeLanguage: 'html',
		editorSize: 'large',
		isBinding: false,
		isMandatory: () => true,
	})
	html: HtmlType = ''

	@jsonProperty()
	@ScreenEditorInput({
		inputType: 'checkbox',
		order: 2,
		label: 'Encapsulate in component',
	})
	encapsulateInComponent: boolean = false

	constructor(init: Partial<RawHtmlBlock> = {}) {
		super()
		this.init(init)
	}
}
